import { render, staticRenderFns } from "./ECommerceCollectCleanLayout.vue?vue&type=template&id=de5972b4&scoped=true&"
import script from "./ECommerceCollectCleanLayout.vue?vue&type=script&lang=js&"
export * from "./ECommerceCollectCleanLayout.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceCollectCleanLayout.vue?vue&type=style&index=0&id=de5972b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5972b4",
  null
  
)

export default component.exports